<full-loader></full-loader>
<app-alert></app-alert>
<app-dialog></app-dialog>
<app-header></app-header>
<app-breadcrumb></app-breadcrumb>
<div class="router-container">
    <router-outlet></router-outlet>
</div>
<app-cookies></app-cookies>
<app-footer></app-footer>